module.exports = __webpack_public_path__ + "img/Local-Clips-Option-2.604c416b.png";